import {Params} from "@angular/router";
import {Placement} from "@ng-bootstrap/ng-bootstrap";
//import {RangeDateDefaultFilter} from '@shared/utils';

export type RangeDateDefaultFilter = 'Today' | 'ThisWeek' | 'ThisMonth' | '7d' | '14d' | '30d' | '60d' | '90d';
export type ILanguageCodes = 'vi-VN' | 'en-US';


export type IDataExportSpreadData = {
  spreadId: string,
  spreadUrl: string,
  spreadSheetId: number,
  spreadSheetTitle: string,
}

export interface IResDataExportData {
  totalPages: number,
  totalItems: number,
  page: number,
  spreadData: IDataExportSpreadData,
  next?: any[],
}

/**
 * dung cho các case;
 * - Chưa gắn user
 * - Chưa gắn kho
 */
export const UNPOPULATED_VALUE = -1

export interface IResElasticLog<T = any[]> {
  elPagePrev: string,
  next: any[],
  totalItems: number,
  result: T,
}

export interface IResDataElasticDefault<T = any[]> {
  totalItems: number,
  next: any[],
  result: T
}


// Response trường hợp data trả về mảng kết quả
export interface IResDataArrApi {
  code: number,
  errorCode: string,
  messages: any[],
  data: any[]
}

export interface IProgressBar {
  show: boolean,
  progress: number,
}


export interface INormalObject {
  id: number,
  name: string
}

export interface ISelectOption {
  value: any,
  label: any,
  description?: string,
  disable?: boolean,
  nameOriginal?: string,
  options?: ISelectOption[], // TH select optgroup
  // Hiển thị icon bên trái của option | hiện tại chỉ dùng với select không dùng multiple
  iconLeft?: {
    classFont: string, // Class icon buộc phải có
    text?: string, // Text hiển thị đi kèm icon
    title?: string, // Hiển thị title nếu có
    imageSrc?: string, // URL ảnh icon (thay thế classFont nếu là ảnh)
  },
  // Các thuộc tính xử lý FE
  active?: boolean,
  checked?: boolean,
  display?: boolean,
}

type IBadgeBg =
  'bg-teal'
  | 'bg-success'
  | 'bg-indigo'
  | 'bg-purple'
  | 'bg-pink'
  | 'bg-yellow'
  | 'bg-primary'
  | 'bg-secondary'
  | 'bg-info'
  | 'bg-warning'
  | 'bg-danger'
  | 'bg-light'
  | 'bg-dark'
  | 'bg-black'
  | 'badge-info'
  | 'bg-brown-400'
  | 'bg-blue-600'
  | 'bg-orange-400'
  | 'bg-flat'

/**
 * interface nav tabs in component data gird
 * */
export type INavTabDataGird = Record<string, any> & {
  // ref Dùng khi muốn tìm 1 tab thông qua ref này
  // VD: các trang danh sách có hiển thị số liệu badge thì khi lấy được thông tin từ api cần tìm ref để update giá trị
  //
  ref?: string | number,
  name: string,
  nameOriginal?: string,
  routerLink?: string,
  queryParams?: Params,
  class?: string,
  isActive?: boolean,
  disabled?: boolean, // Dùng khi muốn disabled tab
  permission?: string | string[], // Chỉ dùng khi tab chuyển trang thì cần kiểm tra quyền
  icon?: string,
  channel?: number, // Hiển thị logo kênh qua app-icon-channel
  image?: string,
  iconOnly?: boolean,
  badge?: {
    bg?: IBadgeBg,
    value: number|string,
    color?: string,
    // Chỉ 1 số trang liên quan đến đơn hàng key trả trong api loadNumer là string theo trang thái mới dùng
    // VD: {tabConfirm: 1, tabPacking: 1,...}
    keyValue?: string | number
  },
  childs?: INavTabDataGird[]
}

export type INavTabNew = Record<string, any> & {
  tabRef: string | number;
  name: string,
  nameOriginal?: string,
  routerLink?: string,
  queryParams?: Params,
  isActive?: boolean,
  permission?: string | string[], // Chỉ dùng khi tab chuyển trang thì cần kiểm tra quyền
  icon?: string,
  badge?: {
    bg?: IBadgeBg,
    value: number,
    color?: string,
    // Chỉ 1 số trang liên quan đến đơn hàng key trả trong api loadNumer là string theo trang thái mới dùng
    // VD: {tabConfirm: 1, tabPacking: 1,...}
    keyValue?: string | number
  },
  class?: string
  childs?: INavTabNew[]
}

export type INavTabSavedFilter = {
  isActiveDefault?: boolean, // Lưu lại giá trị tab mặc định được active = true trong component.ts khởi tạo
  actived?: boolean, // Actived tab khi bấm chuyển tab
  tab?: INavTabNew, // Chỉ khi màn hình có tab mặc định thì mới có dữ liệu
}

// Hợp nhất giữa 2 kiểu tab, sau check code sẽ bỏ 1 loại
export type INavTabHybrid = INavTabDataGird | INavTabNew


export interface IPagingDatagrid {
  page: number,
  pageSize: number,
  pageTotal: number,
  totalItems: number,
  lastSort: string,
}

/**
 * ---------------------------------------------------------------------------------------------------------------------
 * App Service ---------------------------------------------------------------------------------------------------------
 * ---------------------------------------------------------------------------------------------------------------------
 * */
// Mục đích để bắn thông báo sự kiện theo data tùy biến
export interface ISubEvents<T = any> {
  type: string | 'chaneBusinessId',
  noEmit?: boolean,
  data: T
}

export enum SUB_EVENT_APP {
  CHANGE_SETTING_COLUMN = 'CHANGE_SETTING_COLUMN',
  PRODUCT_CHANGE_VIEW_TYPE = 'PRODUCT_CHANGE_VIEW_TYPE'
}

/**
 * Label đang bắt buộc nếu ai sử dụng tình huống nào mà cần đổi sang empty thì cần ghi chú thêm ở đây
 * */
export interface Ibreadcrumb {
  icon?: string,
  label: string,
  link?: string,
  active?: boolean,
  subHighlight?: string | number,
  queryParams?: object,
  badge?: { class?: string, text: string },
  labelOriginal?: string | number, // sử dụng trong trường hợp không cần dịch label (hỗ trợ cả ID)
  id?: string, // dùng để hiện thị id ở bread crumb (ví dụ ShippingHandoverViewComponent)
}


/**
 * ---------------------------------------------------------------------------------------------------------------------
 * Form Filter ---------------------------------------------------------------------------------------------------------
 * ---------------------------------------------------------------------------------------------------------------------
 * */
type FormFieldType =
  'text'
  | 'hidden'
  | 'select'
  | 'selectGroup'
  | 'select2'
  | 'checkbox'
  | 'tmpDateSingle'
  | 'tmpDateRange2'
  | 'tpmGroupInputs'
  | 'tmpSuggest'
  | 'externalLink'
  | 'tmpDateMonth'
  | 'selectPages';
type CompSuggestName =
  'staff'
  | 'traffic-source'
  | 'product'
  | 'customer'
  | 'supplier'
  | 'brand'
  | 'accounting-account'
  | 'accounting-contact'
  | 'creator'
  | 'internal'
  | 'domain'
  | 'template'
  | 'product-batch'
  | 'tag'
  | 'business';


type NonEmptyString<T extends string> = T extends '' ? never : T;


type frmFilterConfig = (<S extends string>(arg: { key: NonEmptyString<S> }) => IStrictFilter)

interface IStrictFilter {
  key: string; // Đối với groupInputs thì vẫn nên đặt 1 key nào đó để tiện xử lý mở rộng hơn
  type: FormFieldType; // Không truuyền thì mặc định là text | dùng suggest comp thì set về hidden
  label: string;
  placeholder?: string;
  value?: string | number | any[], // value defaut | value checkbox
  isFirstOption?: boolean, // lấy giá trị mặc định của option trong select, hay dùng trong chọn dn, page, mặc định lấy luôn dn đầu tiên
  typeValue?: 'text' | 'number'; // Mặc định không khai báo thì hiều là string
  autofocus?: boolean;
  suggest?: {
    component: CompSuggestName, // Loại component suggest muốn hiển thị
    paramName: string, // Key dùng để biết đc cần lấy param nào trên url để gắn trị hiển thị cho component suggest
    suggestField?: string, // Field cần tìm kiếm
    // Key liên quan sẽ được update giá trị từ suggest
    // VD: Tìm khách hàng theo MST thì khi tìm thấy sẽ cập nhật customerId nhận được
    relatedKey?: string, //
  };
  multiple?: boolean; // Chỉ dùng với loại select2, selectPages
  formControl?: any; // Khai báo control dùng để tạo form filter, trường bắt buộc khai báo
  options?: ISelectOption[],
  required?: boolean; // Đánh dấu là trường bắt buộc nhập, danh sách active sẽ không cho xóa giá trị đi
  isPin?: boolean; // Screen có áp dụng đánh dấu Pin thì chỉ show những trường isPin,
  sortPin?: number; // Sort value by isPin
  noAutoLoadOptions?: boolean; // Mặc định những trường như depotId sẽ được load dữ liệu chung, nếu == true thì k load chung
  isDisable?: boolean;
  checked?: boolean; // Chỉ có khi dùng type == checkbox
  typeBasic?: 'important' | true; // Đánh dấu các tiêu chi lọc mặc định hiển thị trên màn hình luôn
  /*
  * Số sắp xếp thứ tự hiển thị filter basic theo tùy chỉnh của màn hình, tình huống:
  * - Filter basic: A => B => C => D
  * - Filter advance: B => A => D => C
  * */
  sortFilterBasic?: number,
  className?: string // Thêm class attribute cho dropdown-menu của select option filter
  disableLabelTranslate?: boolean, // Biến đánh dấu không cần dịch label của filter
  placeholderOriginal?: string, // placeholder mặc định không cần dịch của filter
  placeholderCanonical?: string // Dùng với 1 số tình huống đặc biệt luôn cần hiển thị placeholder trong bộ lọc "basic hoặc advanced"
  externalLink?: string, // Dùng với filter dạng show thẻ <a> để điều hướng ra bên ngoài
  selectConfig?: {
    // Option đánh dấu cần gắn thêm option default trong filter
    // VD: "Chưa gắn kho"
    unpopulatedOption?: boolean,
    itemHeight?: number, // Selection option có thể hiện 2-3 dòng text thì cần cân nhắc tăng itemHeight VD 2 dòng = 68, 3 dòng = 89
    showSearch?: boolean,
  },
  selectPagesConfig?: {
    groupByChannel?: boolean;
    showModeOptions?: boolean;
    channels?: number[];
  },
  permission?: string, // Hiển thị theo phân quyền
  extendParams?: Params, // truyền thêm param cho suggest
  valueInstance?: any[] | any, // dùng để lưu giá trị khai báo đầu tiên
}

export type IFrmFilterGroup = Omit<IStrictFilter, 'label' | 'type'> & {
  type: 'text' | 'select' | 'select2' | 'datePicker' | 'checkbox' | 'tmpSuggest' | 'optgroup' | 'monthPicker' | 'selectPages',
  label?: string; // Trong group thì label là không bắt buộc nữa
};

export type IFrmFilterCommon = IStrictFilter & {
  rightIcon?: string,
  rightIconTooltip?: string,
  groupInputs?: {
    // Giá trị phải là key translate, hiện mới thấy trang /order/manage/index có tooltip cuối group
    tooltip?: string,
    childs: IFrmFilterGroup[],
    // Tổng tiền: = - 200000 => ở trường hợp này thì không muốn hiển thị "-" thì có thể chủ động truyền ký tự muốn hiển thị
    // Mặc định thì sẽ join(' - ')
    operator?: string,
  },
  dateRange?: {
    // Giá trị phải là key translate, hiện mới thấy trang /order/manage/index có tooltip cuối group
    tooltip?: string,
    fromDate: IFrmFilterGroup,
    toDate: IFrmFilterGroup,
    placement?: Placement, // Một số bộ lọc dài date rang bị che, cho hiển thị tùy từng màn
    rangeActive?: string, // Lưu lựa chọn khoảng nhanh, mặc định là undefined
    outputFormat?: 'date' | 'timestamp', // format output theo common date hoặc timestamp, mặc định 'date' //RangeDateDefaultFilter
    rangeDateDefaultFilter?: RangeDateDefaultFilter
    unitLimit?: 'day' | 'month' | 'year', // giới hạn lọc khi chọn
    numberLimit?: number, // số giới hạn lọc
    singleDatePicker?: boolean, // Chỉ hiển thị 1 lịch và sử dụng fromDate làm giá trị
  },
  periodDate?: {
    // Sử dụng trong trường hợp muốn lọc theo kỳ
    theFromDate: IFrmFilterGroup,
    theToDate: IFrmFilterGroup,
    lastFromDate: IFrmFilterGroup,
    lastToDate: IFrmFilterGroup
  },
  basicConfig?: {
    maxWidth?: string, // độ rộng width của input, mặc định 8rem
  }
}


/**
 * ---------------------------------------------------------------------------------------------------------------------
 * CkEditor ---------------------------------------------------------------------------------------------------------
 * ---------------------------------------------------------------------------------------------------------------------
 * */
export interface IDataOutputCkeditor {
  field: string,
  html: string,
  images: string[]
}

/**
 * ---------------------------------------------------------------------------------------------------------------------
 * Sortable ---------------------------------------------------------------------------------------------------------
 * ---------------------------------------------------------------------------------------------------------------------
 * */
export interface ISortData {
  id: number,
  order: number
}


/**
 * ---------------------------------------------------------------------------------------------------------------------
 * Shared component ---------------------------------------------------------------------------------------------------------
 * ---------------------------------------------------------------------------------------------------------------------
 * */
export interface IAfterSubmitRadio {
  value: string,
  name: string,
  checked: boolean,
}

export const OPERATORS = {
  OPERATOR_EQUAL: 1,
  OPERATOR_GREATER: 2,
  OPERATOR_LESSER: 3,
  OPERATOR_DIFFERENT: 4,
  getOperators: () => {
    const res: any[] = [];
    for (const [k, v] of Object.entries(operators)) {
      res.push({label: v, value: parseInt(k)})
    }
    return res;
  },
};
const operators: Record<number, string> = {
  [OPERATORS.OPERATOR_EQUAL]: "=",
  [OPERATORS.OPERATOR_GREATER]: ">",
  [OPERATORS.OPERATOR_LESSER]: "<",
  [OPERATORS.OPERATOR_DIFFERENT]: "!="
}

export const NORMALOPERATORS = {
  OPERATOR_EQUAL_GREATER: 5,
  OPERATOR_EQUAL_LESSER: 6,
  OPERATOR_DIFFERENT: 4,
  getNormalOperators: () => {
    const res: any[] = [];
    for (const [k, v] of Object.entries(normaloperators)) {
      res.push({label: v, value: parseInt(k)})
    }
    return res;
  },
};
const normaloperators: Record<number, string> = {
  [NORMALOPERATORS.OPERATOR_EQUAL_GREATER]: ">=",
  [NORMALOPERATORS.OPERATOR_EQUAL_LESSER]: "<=",
  [NORMALOPERATORS.OPERATOR_DIFFERENT]: "!="
}

export interface RouteNode {
  path: string; // path của route hiện tại
  fullPath: string; // đường dẫn đầy đủ (đã ghép từ cha và con)
  component?: any; // component nếu có
  data?: any; // data nếu có
  children?: RouteNode[]; // danh sách children (nếu có)
}
